import React from 'react';
import { KeyValueTable } from './KeyValueTable';
import { Card } from '../Card/Card';
import { Icon } from '../Icon/Icon';

export function KeyValueTableExample(): JSX.Element {
  return (
    <Card>
      <KeyValueTable
        labelWidth={300}
        items={[
          {
            key: 'Billing contact',
            value: 'christian@nerdgeschoss.de',
            style: {
              height: '38px',
            },
          },
          {
            key: 'EU VAT ID(optional)',
            value: 'DE123456122345',
          },
          {
            key: 'Tax Number(optional)',
            value: '12 / 234 / 98685',
            style: {
              height: '38px',
            },
          },
          {
            key: `Bank account holder's name`,
            value: 'Landstreicher Booking GmbH',
          },
          {
            key: 'IBAN',
            value: 'DE4912391239124193',
          },
          {
            key: 'BIC',
            value: 'DBDEBERXXX',
            style: {
              height: '38px',
            },
          },
          {
            key: 'reference',
            keyNode: (
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <span>Your reference: </span>
                <Icon
                  style={{
                    display: 'inline-flex',
                    height: '10px',
                    width: '10px',
                    background: 'gray',
                    borderRadius: '50%',
                    color: 'white',
                    padding: '3px',
                    marginLeft: '5px',
                  }}
                  name="plus"
                />
              </span>
            ),
            value: 'KS XYZ 33451',
          },
        ]}
      />
    </Card>
  );
}
